import React from 'react'
import Login from '../features/auth/components/Login'

export default function LoginPage() {
  return (
    <div>
      <Login/>
    </div>
  )
}
